import React from "react";

const services = [
    {
        title: "Buy Your Dream Home",
        description:
            "Discover properties that match your lifestyle with our personalized home search. Get expert guidance through every step of the home buying process.",
        image: "assets/images/service1.png",
    },
    {
        title: "Sell with Confidence",
        description:
            "Maximize your property's value with our strategic marketing plans and extensive network of qualified buyers. Get the best price for your property.",
        image: "assets/images/service2.png",
    },
    {
        title: "Premium Rentals",
        description:
            "Find your perfect rental property from our curated selection. We handle everything from viewings to lease agreements.",
        image: "assets/images/service3.png",
    },
];

const RealtorServices = () => {
    return (
        <section className="py-10 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 xl:px-20 bg-white font-poppins">
            <div className="container mx-auto max-w-7xl">
                {/* Title */}
                <div className="max-w-3xl mx-auto text-center">
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4">
                        Comprehensive Real Estate Solutions
                    </h2>
                    <p className="text-[#212121] text-sm sm:text-[15px] leading-relaxed">
                        Our full-service real estate company offers expert guidance for all your property needs. 
                        From first-time buyers to seasoned investors, we provide tailored solutions to help you 
                        achieve your real estate goals with confidence.
                    </p>
                </div>

                {/* Services */}
                <div className="mt-10 sm:mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
                    {services.map((service, index) => (
                        <div
                            key={index}
                            className="bg-white border border-gray-200 rounded-xl pt-4 sm:pt-6 pb-6 sm:pb-8 px-4 sm:px-6 shadow-sm hover:shadow-lg transition-all duration-300 text-center hover:border-gray-50 flex flex-col"
                        >
                            <div className="h-32 sm:h-40 flex items-center justify-center mb-3 sm:mb-4">
                                <img
                                    src={service.image}
                                    alt={service.title}
                                    className="h-full w-auto object-contain"
                                />
                            </div>
                            <h3 className="text-lg sm:text-xl md:text-[22px] font-semibold mb-2 sm:mb-3">
                                {service.title}
                            </h3>
                            <p className="text-gray-700 text-sm sm:text-[15px] leading-relaxed mb-4 sm:mb-6 font-normal flex-grow">
                                {service.description}
                            </p>
                            <div className="mt-auto">
                                <a 
                                    href="#contact"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        const contactSection = document.getElementById('contact');
                                        if (contactSection) {
                                            contactSection.scrollIntoView({ behavior: 'smooth' });
                                        }
                                    }}
                                    className="inline-flex items-center justify-center w-[150px] h-10 sm:h-[40px] bg-[#041c77] hover:bg-[#030f3a] text-white py-2 rounded-full font-medium transition-colors duration-300 text-sm sm:text-base mx-auto"
                                >
                                    Contact Now
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default RealtorServices;